import React from "react";
import PropTypes from "prop-types";
import store from "../../state/store";

function VariantForGenome({ variant, genomeKey }) {
  if (!variant || !variant[genomeKey]) return null;
  const item = variant[genomeKey];
  const { variant_id: id, spec } = item;
  const url = `${store.getState().varsomeHost}/variant/${id}`;
  return (
    <div
      className="tw-flex tw-gap-2 tw-items-center tw-flex-wrap"
      key={item.spec}
    >
      <b>{`${genomeKey}`}</b>
      <a
        target="_blank"
        className=" tw-whitespace-no-wrap"
        href={url}
        title="Open in a new tab"
      >
        {spec}
      </a>
    </div>
  );
}

VariantForGenome.propTypes = {
  variant: PropTypes.shape({}),
  genomeKey: PropTypes.string,
};

VariantForGenome.defaultProps = {
  variant: null,
  genomeKey: null,
};

export default VariantForGenome;
